<style></style>

<template>
  <div class="col-lg-12">
    <div class="main-card mb-3 card" style="margin: 20px">
      <div class="card-body">
        <h5 class="card-title">
          학습변경관리
          <!--<div class="sub_title">학습변경관리</div>-->
        </h5>
        <div
          class="sub_title"
          style="
            margin-bottom: 20px;
            color: #333;
            font-size: 13px;
            border: 1px solid #ccc;
            background: #f8f8f8;
            height: 30px;
            text-align: right;
            position: absolute;
            right: 20px;
            top: 10px;
            padding: 4px 10px 2px 10px;
          "
        >
          학습변경관리
        </div>
        <p
          style="
            font-size: 15px;
            margin-top: 10px;
            line-height: 25px;
            color: #004279;
            font-weight: 500;
          "
        >
          - 학습변경(레벨변경, 과목변경 등)의 신청 및 이력을 확인합니다.
        </p>
        <query-grid :config="config">
          <template #items="props">
            <tr v-for="record in props.records" v-bind:key="record.id">
              <th scope="row">{{ record.id }}</th>
              <td
                v-if="
                  this.$root.guiPerm != 'ENTERPRISE' &&
                  this.$root.guiPerm != 'CLASS'
                "
              >
                <Business :biz="record.b2" />
              </td>
              <td>
                <Business :biz="record.b1" />
              </td>

              <td>{{ record.username }}</td>
              <td>
                <Student
                  :student="{ id: record.student_id, name: record.name }"
                />
              </td>
              <td>
                <template v-if="record.reqType == 'reset'">초기화</template>
                <template v-if="record.reqType == 'level'">레벨변경</template>
                <template v-if="record.reqType == 'subject'">과목변경</template>
                
              </td>
              <td>{{ str_f(record.srcLevel,record.reqType) }}</td>
              <td>{{ str_f(record.dstLevel,record.reqType) }}</td>
              <td>{{ record.createdAt }}</td>

              <td>{{ record.reqAdmin }}</td>
              <td
                v-if="
                  this.$root.guiPerm != 'ENTERPRISE' &&
                  this.$root.guiPerm != 'CLASS'
                "
              >
                {{ record.appAdmin }}
              </td>
              <td>
                <template v-if="record.status == 'REQUESTED'"
                  ><span class="btn-primary btn-sm">요청</span></template
                >
                <template v-if="record.status == 'CANCELLED'"
                  ><span class="btn-danger btn-sm">취소됨</span></template
                >
                <template v-if="record.status == 'PENDING'"
                  ><span class="btn-warning btn-sm">보류</span></template
                >
                <template v-if="record.status == 'ACCEPTED'"
                  ><span class="btn-success btn-sm">완료</span></template
                >
                <template v-if="record.status == 'DIRECT'"
                  ><span class="btn-success btn-sm"
                    >본사 직접변경</span
                  ></template
                >
                <template v-if="record.status == 'REJECTED'"
                  ><span class="btn-info btn-sm">반려</span></template
                >
              </td>
              <td>{{ record.finishedAt }}</td>
              <td>
                <button
                  class="btn btn-success btn-sm"
                  @click="approve(record)"
                  v-if="
                    (record.status == 'REQUESTED' ||
                      record.status == 'PENDING') &&
                    this.$root.guiPerm == 'ROOT'
                  "
                >
                  승인
                </button>
                <button
                  class="btn btn-warning btn-sm"
                  @click="update(record, 'PENDING')"
                  v-if="
                    record.status == 'REQUESTED' && this.$root.guiPerm == 'ROOT'
                  "
                >
                  보류
                </button>
                <button
                  class="btn btn-danger btn-sm"
                  @click="update(record, 'REJECTED')"
                  v-if="
                    (record.status == 'REQUESTED' ||
                      record.status == 'PENDING') &&
                    this.$root.guiPerm == 'ROOT'
                  "
                >
                  반려
                </button>
                <button
                  class="btn btn-danger btn-sm"
                  @click="this.delete(record)"
                  v-if="
                    (record.status == 'REQUESTED' ||
                      record.status == 'PENDING') &&
                    this.$root.guiPerm != 'ROOT'
                  "
                >
                  신청 취소
                </button>
              </td>
            </tr>
          </template>
        </query-grid>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import treeBtn from "../components/treeBtn";
import Business from "../components/Business";
import QueryGrid from "../components/QueryGrid";
import Student from "../components/detail_pages/Student.vue";
import axios from "axios";
export default {
  name: "Home",
  components: {
    Tree,
    treeBtn,
    Business,
    Student,
    QueryGrid,
  },
  mounted() {
    //this.search();
    if (this.$root.guiPerm == "ENTERPRISE" || this.$root.guiPerm == "CLASS") {
      this.config.columns = this.config.columns.filter(function (el) {
        return el.id != "appAdmin" && el.id != "business";
      });
    } else if (this.$root.guiPerm == "ROOT") {
      this.config.search_fields[1].filter_type.DIRECT = "본사직접변경";
    }
  },
  methods: {
    //글자자르기
    str_f(a,type){
      if(type === "subject"){
      var b = a.substr(0, a.length-1);
      return b;
      }else{
        return a;
      }
    },
    approve(record) {
      // approve 쪽에서 자동으로 바꿈

      if( record.reqType === "subject"){

        this.update(record, "ACCEPTED");

      }else{
      axios
        .patch("/subscriptions/" + record.subscriptionId, {
          level: record.dstLevel,
          ref: record.id,
        })
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "변경실패: " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            $.notify(
              {
                // options
                message:
                  response.data.status == "requested"
                    ? "변경 요청되었습니다. "
                    : "변경되었습니다.",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
            this.search();
          }
        });


      }


    },
    update(record, status) {
      var msg = "변경되었습니다";
      if(status === "ACCEPTED"){
        msg = "승인처리 되었습니다. \n 실제 과목변경은 회원관리메뉴에서 진행해주세요. ";
      }
      axios
        .patch(
          "/subscriptions/" + record.subscriptionId + "/requests/" + record.id,
          {
            status: status,
          }
        )
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "변경실패: " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            $.notify(
              {
                // options
                message: msg,
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
            this.search();
          }
        });
    },
    delete(record) {
      axios
        .delete(
          "/subscriptions/" + record.subscriptionId + "/requests/" + record.id
        )
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "취소실패: " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            $.notify(
              {
                // options
                message: "취소되었습니다.",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
            this.search();
          }
        });
    },
  },
  data() {
    return {
      config: {
        name: "레벨변경신청",
        req_endpoint: "/studies/levelrequests",
        default_limit: 20,
        search_fields: [
          {
            id: "businesses",
            name: "소속선택",
            type: "business", // business, date, datetime,
          },
          {
            id: "status_filter",
            name: "상태",
            type: "switch",
            filter_type: {
              REQUESTED: "요청",
              CANCELLED: "취소",
              PENDING: "보류",
              ACCEPTED: "완료",
              REJECTED: "반려",
            },
          },
          {
            id: "search",
            name: "키워드검색",
            type: "text",
            placeholder:
              "#NO/학원/클래스/아이디/이름/학생번호/요청관리자/승인관리자",
          },

          {
            id: "date",
            name: "날짜검색",
            type: "date",
            filter_type: {
              created_at: "신청일",
              finished_at: "최종처리일",
            },
          },
          {
            id: "type",
            name: "구분",
            type: "switch",
            filter_type: {
              reset: "초기화",
              level: "레벨변경",
              subject: "과목변경",
            },
          },
        ],
        columns: [
          {
            id: "id",
            sortable: true,
            name: "# NO",
            excel_print: (v) => {
              return v.id;
            },
          },
          {
            id: "business",
            sortable: true,
            name: "학원",
            excel_print: (v) => {
              return v.b1.name;
            },
          },
          {
            id: "class",
            sortable: true,
            name: "클래스",
            excel_print: (v) => {
              return v.b2.name;
            },
          },
          {
            id: "username",
            sortable: true,
            name: "ID",
            excel_print: (v) => {
              return v.username;
            },
          },
          {
            id: "name",
            name: "이름",
            sortable: true,
            excel_print: (v) => {
              return v.name;
            },
          },
          {
            id: "type",
            name: "구분",
            sortable: true,
            excel_print: (v) => {
              return v.reqType;
            },
          },
          {
            id: "srcLevel",
            name: "변경전",
            sortable: true,
            excel_print: (v) => {
              return v.srcLevel;
            },
          },
          {
            id: "dstLevel",
            name: "변경후",
            sortable: true,
            excel_print: (v) => {
              return v.dstLevel;
            },
          },
          {
            id: "created_at",
            name: "신청일",
            sortable: true,
            excel_print: (v) => {
              return v.createdAt;
            },
          },
          {
            id: "reqAdmin",
            name: "신청관리자",
            sortable: true,
            excel_print: (v) => {
              return v.reqAdmin;
            },
          },
          {
            id: "appAdmin",
            name: "승인관리자",
            sortable: true,
            excel_print: (v) => {
              return v.appAdmin || "";
            },
          },
          {
            id: "status",
            sortable: true,
            name: "상태",
            excel_print: (v) => {
              var a = {
                REQUESTED: "요청",
                CANCELLED: "취소",
                PENDING: "보류",
                ACCEPTED: "완료",
                REJECTED: "반려",
                DIRECT: "본사 직접변경",
              };
              return a[v.status];
            },
          },
          {
            id: "finished_at",
            name: "최종처리일",
            sortable: true,
            excel_print: (v) => {
              return v.finishedAt || "";
            },
          },
          {
            id: "action",
            name: "작업",
          },
        ],
      },
    };
  },
};
</script>
